
'use client'

import { useEffect } from 'react';

export default function DbInitializer({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    const abortController = new AbortController();
    fetch('/api/initialize-db', { signal: abortController.signal }).catch(() => undefined);

    return () => {
      abortController.abort();
    };
  }, []);

  return <>{children}</>;
}
